













































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Dropdown from './BaseDropdown.vue'
import TextInput from './BaseTextInput.vue'
import states from '../utils/states'
import provinces from '../utils/provinces'
import countries from '../utils/countries'

@Component({
  components: { TextInput, Dropdown },
})
export default class BaseAddress extends Vue {
  @Prop({ type: Boolean, default: false }) editMode: boolean
  @Prop({ type: String, default: '' }) autoCompleteToken: string
  // @Prop() name: string
  @Prop() givenName: string
  @Prop() familyName: string
  @Prop() address_1: string
  @Prop() address_2: string
  @Prop() city: string
  @Prop() state: string
  @Prop() zip: string
  @Prop() country: string

  states = states
  provinces = provinces
  countries = countries.reduce((carry: any, [label, code]) => {
    carry[label] = code
    return carry
  }, {})

  handleGooglePlaceChange (value: GooglePlace) {
    console.log('google place', value)
    const address: Address = {
      // name: this.name,
      givenName: this.givenName,
      familyName: this.familyName,
      address_1: (value.streetNumber && value.route) ? `${value.streetNumber} ${value.route}` : '',
      address_2: '',
      city: value.city,
      state: value.state,
      zip: value.zip,
      country: value.country
    }
    this.$emit('replaceAddress', address)
  }

  handleGivenName (value: string) {
    this.$emit('input', { name: 'givenName', value })
  }

  handleFamilyName (value: string) {
    this.$emit('input', { name: 'familyName', value })
  }

  handleAddress1 (value: string) {
    this.$emit('input', { name: 'address_1', value })
  }

  handleAddress2 (value: string) {
    this.$emit('input', { name: 'address_2', value })
  }

  handleCity (value: string) {
    this.$emit('input', { name: 'city', value })
  }

  handleState (value: string) {
    this.$emit('input', { name: 'state', value })
  }

  handleZip (value: string) {
    this.$emit('input', { name: 'zip', value })
  }

  handleCountry (value: string) {
    this.$emit('input', { name: 'country', value })
  }

  handleBlur (name: string, value: string) {
    this.$emit('blur', name, value)
  }
}

